function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
import * as schedule from '@/api/schedule.js';
import creatJob from './creatJob';
import { Debounce } from '@/utils/validate';
import { checkPermi } from '@/utils/permission';
var createDefaultJob = function createDefaultJob() {
  return {
    jobId: 0,
    beanName: '',
    cronExpression: '',
    methodName: '',
    remark: '',
    params: '',
    dispatchStrategy: 'ROUND_ROBIN'
  };
};
export default {
  name: 'list',
  components: {
    creatJob: creatJob
  },
  data: function data() {
    return {
      tableData: [],
      listLoading: false,
      dialogVisible: false,
      status: 0,
      jobId: 0,
      editData: createDefaultJob(),
      strategyOptions: [{
        label: '轮询调度',
        value: 'ROUND_ROBIN',
        desc: '节点轮流执行任务，保证分布式实例均衡运行。'
      }, {
        label: '权重轮询',
        value: 'WEIGHTED',
        desc: '根据调度节点权重决定执行频次，类似 XXL-JOB 的一致性哈希/最少执行策略。'
      }, {
        label: '分片广播',
        value: 'SHARDING',
        desc: '每一个在线调度节点都会执行一次，可结合分片序号拆分业务数据处理。'
      }]
    };
  },
  created: function created() {
    if (checkPermi(['admin:schedule:job:list'])) this.getjobList();
  },
  methods: {
    checkPermi: checkPermi,
    //权限控制
    // 获取定时任务列表
    getjobList: function getjobList() {
      var _this = this;
      this.listLoading = true;
      schedule.jobList().then(function (data) {
        _this.listLoading = false;
        _this.tableData = data;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    submit: Debounce(function (data) {}),
    //  关闭模态框
    handleClose: function handleClose(done) {
      this.formConf.fields = [];
      this.dialogVisible = false;
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this2 = this;
      if (row.status == 1) {
        schedule.scheduleJobSuspend(row.jobId).then(function () {
          _this2.$message.success('修改成功');
          _this2.getjobList();
        }).catch(function () {
          row.status = !row.status;
        });
      } else {
        schedule.scheduleJobStart(row.jobId).then(function () {
          _this2.$message.success('修改成功');
          _this2.getjobList();
        }).catch(function () {
          row.status = !row.status;
        });
      }
    },
    // 添加定时任务
    handleAddJob: function handleAddJob() {
      this.editData = createDefaultJob();
      this.dialogVisible = true;
    },
    // 修改定时任务
    onEdit: function onEdit(row) {
      this.editData = _objectSpread(_objectSpread({}, row), {}, {
        dispatchStrategy: row.dispatchStrategy || 'ROUND_ROBIN'
      });
      this.dialogVisible = true;
    },
    getStrategyLabel: function getStrategyLabel(code) {
      var strategy = this.strategyOptions.find(function (item) {
        return item.value === code;
      });
      return strategy && strategy.label || '轮询调度';
    },
    getStrategyDesc: function getStrategyDesc(code) {
      var strategy = this.strategyOptions.find(function (item) {
        return item.value === code;
      });
      return strategy && strategy.desc || '节点轮流执行任务';
    },
    onTrig: function onTrig(row) {
      var _this3 = this;
      schedule.scheduleJobTrig(row.jobId).then(function (res) {
        _this3.$message.success('触发成功');
        _this3.getjobList();
      });
    },
    closeModel: function closeModel() {
      this.dialogVisible = false;
    },
    // 删除定时任务
    handleDelete: function handleDelete(id, idx) {
      var _this4 = this;
      this.$modalSure().then(function () {
        schedule.scheduleJobDelete(id).then(function (res) {
          _this4.$message.success('删除成功');
          _this4.getjobList();
        });
      });
    }
  }
};